<script>
import { mapGetters } from 'vuex';
import { Loading } from 'element-ui';

export default {
  data() {
    return {
      loadingInstance: null,
      timerId: '',
      time: 0
    };
  },
  computed: {
    ...mapGetters(['isLoading', 'loadingText'])
  },
  watch: {
    isLoading(value) {
      if (value) {
        this.timerId = setTimeout(() => {
          // 所有loading延迟200ms展示
          this.loadingInstance = Loading.service({ fullscreen: true, text: this.loadingText });
          this.time = new Date().getTime();
        }, 200);
      } else {
        // 小于200ms的不展示
        if (this.timerId) {
          clearTimeout(this.timerId);
          this.timerId = '';
        }
        let diff = 500;
        if (this.time) {
          // 计算已经展示时间
          diff = new Date().getTime() - this.time;
          this.time = 0;
        }
        // 一旦展示，则至少展示500ms
        if (diff < 500) {
          setTimeout(() => {
            if (this.loadingInstance) this.loadingInstance.close();
          }, 500 - diff);
          return;
        }
        if (this.loadingInstance) this.loadingInstance.close();
      }
    }
  },
  render: h => h()
};
</script>

<style>
